<script setup>
import Alert   from  '@/components/common/Alert.vue';
import Load from '@/components/common/Load.vue'
import MediaExList from "@/components/media/MediaExList.vue";
import SaveDialog from "@/components/media/SaveDialog.vue";
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card
    width="100%"
    flat
    max-height="100vh"
>
    <SaveDialog ref="sd" />
    <MediaExList ref="ex"  />
    <v-card-text class="py-0">
    <v-card
        flat
    >
        <v-card-text>
            <span v-if="list_id == '' || list_id == undefined">候補BOX</span><span>メディアリスト</span>に追加したい場合は以下のフォームに必要事項を入力して<v-icon>mdi-plus</v-icon>を押下してください。メディアをQlipperと紐づけると便利です。Qlipperにメディア候補が存在しない場合はメディア名をそのまま入力してください。
        </v-card-text>
        <v-card-text class="pt-1">
        <v-row class="mt-2">
            <v-col cols="2">
        <v-select
            v-model="contact_cd"
            :items="items"
            item-text="label"
            item-value="cd"
            label="送信方法"
            clearable
            hide-details="auto"
            dense
        >
        </v-select>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    v-model="media_name"
                    :items="mediaitems"
                    :loading="isLoading"
                    :search-input.sync="search"
                    item-text="media_name"
                    item-value="site_id"
                    placeholder="メディア名を入力してください"
                    prepend-icon="mdi-database-search"
                    clearable
                    dense
                    return-object
                    @blur="text_check"
                ></v-autocomplete>
            </v-col>
            <v-col cols="2">
        <v-text-field
            v-model="addressee"
            clearable
            hide-details="auto"
            dense
            placeholder="宛名"
            outlined
        ></v-text-field>
            </v-col>
            <v-col>
        <v-text-field
            v-model="contact_item"
            clearable
            hide-details="auto"
            dense
            placeholder="連絡先"
            outlined
        ></v-text-field>
            </v-col>
            <v-col cols="1">
                <span class="plus-button">
                <v-icon
                    @click="set"
                >
                    mdi-plus
                </v-icon>
                </span>
            </v-col>
        </v-row>
        </v-card-text>
    </v-card>
    </v-card-text>
    <v-card-text class="py-0">
        <span style="font-weight:bold;font-size:2rem;">{{ dsplist.length }}件</span>
    </v-card-text>
    <v-card-text>
        <v-list v-if="dsplist.length!=0 && isLoading==false" outlined max-height="300px" class="overflow-y-auto">
            <v-list-item v-for="item,index in dsplist" :key="index">
                <v-list-item-icon>
                    <v-icon v-if="item.contact_cd==1">
                        mdi-email-outline
                    </v-icon>
                    <v-icon v-else-if="item.contact_cd==2">
                        mdi-application-outline
                    </v-icon>
                    <img src="rel_image/zip.svg" v-else-if="item.contact_cd==5">
                    <img src="rel_image/fax.svg" v-else-if="item.contact_cd==3">
                </v-list-item-icon>
                <v-list-item-content>
                    <v-row>
                        <v-col cols="2">
                            {{item.site_name}}
                        </v-col>
                        <v-col cols="2">
                            {{item.addressee}}
                        </v-col>
                        <v-col>
                        {{ item.contact_item }}
                        </v-col>
                        <v-col cols="1">
                            <v-icon
                                @click="del(item.id)"
                            >
                                mdi-delete
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <Load v-else-if="this.isLoading==true" />
        <Alert
            message="メディア機能から候補を追加するか、新規に登録してください。"
            messagetitle="メディアリストの連絡先候補が登録されていません。"
            messagetype="0"
            blockheight="200px"
            v-else
        />
    </v-card-text>
    <v-card-actions style="height:100px;position:fixed;bottom:0;width:95%" v-if="list_id == '' || list_id == undefined">
        <v-spacer />
        <v-btn
            @click="newsave"
            color="#E11D31"
            :disabled="updated_flg"
            :dark="!updated_flg"
        >
            <v-icon>mdi-plus</v-icon>新規メディアリストとして保存
        </v-btn>
        <v-btn
            color="#E11D31"
            :dark="!updated_flg"
            @click="existing"
            :disabled="updated_flg"
        >
            <v-icon>mdi-playlist-plus</v-icon>既存メディアリストに追加する
        </v-btn>
        <v-spacer />
    </v-card-actions>
</v-card>
</template>
<script>
export default {
    props : ["list_id",],
    computed : {
        candlist : function(){
            return this.$store.getters["mediacand/get_candlist"];
        },
        mediaitems () {
          return this.entries.map(entry => {
            const media_name = entry.site_name;
            return Object.assign({}, entry, { media_name })
          });
        },

    },
    watch : {
        list_id  : function(){
            if(this.list_id=="" || this.list_id==undefined)
            {
                this.dsplist = this.candlist;
            }
            else
            {
                this.dsplist = [];
                this.get_media_list();
            }
        },
        candlist : function(){
            let flg = false;
            if(this.candlist.length == 0)
            {
                flg=true;
            }
            this.updated_flg=flg;
            this.dsplist  = this.candlist;
        },
        search (val) {
            if(this.search_stop == true)
            {
                this.search_stop = false;
                return;
            }
            if (val == "")
            {
                return ;
            }
            if (this.isLoading) return;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.search_media(val);
            }, 500);
        },
    },
    data : function(){
        return {
            isLoading    : false,
            dsplist      : [],
            timeout      : null,
            search_stop  : false,
            contact_cd   : null,
            media_name   : null,
            addressee    : null,
            search        : null,
            contact_item : null,
            entries     : [],
            updated_flg : true,
            target  : "候補BOX",
            items : [
                {cd : 1 , label : "メール"},
                {cd : 2 , label : "フォーム"},
                {cd : 3 , label : "FAX"},
                {cd : 5 , label : "住所"},
            ],
        };
    },
    methods : {
        existing : function(){
            this.$refs.ex.open();
        },
        newsave : function(){
            this.$refs.sd.open();
        },
        text_check : function(data){
            if(data.target.value != "")
            {
                if(this.media_name == null || (this.media_name != null && this.media_name.id == -1))
                {
                    this.search_stop=true;
                    this.entries = [];
                    this.entries = [{site_name : data.target.value , site_id : -1},];
                    this.media_name = {site_name : data.target.value , site_id : -1};
                }
            }
        },
        get_media_list : async function (){
            this.isLoading = true;
            let params = new URLSearchParams();
            params.append("list_id",this.list_id);
            await axios.post("/api/media/get_media_list",params)
            .then(response => {
                this.dsplist = response.data;
                this.isLoading = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        search_media : async function(val) {
          this.isLoading = true;
          var params = new URLSearchParams();
          params.append("search_word",val);
          await axios.post("/api/media/get_media_summary",params)
          .then(response => {
              this.entries = response.data.list;
              this.isLoading = false;
              if(this.media_name != null)
              {
                    // 変更されたならIDは消す
                    //this.company_name.id=-1;
              }
           }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
           });
        },
        del : function(id){
            let params = new URLSearchParams();
            params.append('id', id);
            if(this.list_id != '' && this.list_id!=undefined)
            {
                params.append('list_id', this.list_id);
            }
            axios.post("/api/media/del_cand_list",params)
            .then(response => {
                if(this.list_id == '' || this.list_id==undefined)
                    this.$store.commit("mediacand/set_candlist",response.data);
                this.dsplist = response.data;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        set : async function(){
            let params = new URLSearchParams();
            params.append('media_name', this.media_name.site_name);
            params.append('site_id', this.media_name.site_id);
            params.append('addressee', this.addressee);
            params.append('contact_item', this.contact_item);
            params.append('contact_cd', this.contact_cd);
            params.append('mode',1);
            if(this.list_id != '' && this.list_id!=undefined)
            {
                params.append('list_id', this.list_id);
            }
            await axios.post("/api/media/set_media_list",params)
            .then(response => {
                if(this.list_id == '' || this.list_id==undefined)
                    this.$store.commit("mediacand/set_candlist",response.data);
                this.dsplist = response.data;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });

        },
    },
    mounted : function(){
        if(this.candlist.length != 0)
        {
            this.updated_flg=false;
        }
        else
        {
            this.updated_flg=true;
        }
        if(this.list_id == "" || this.list_id == undefined)
        {
            this.dsplist = this.candlist;
        }
        else
        {
            this.dsplist = [];
            this.get_media_list();
        }
    },

}
</script>
